import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import type { Achievement } from "../../lib/achievements";

/**
 * Every achievement earned in any month on record. The server reviews each month against the whole
 * ledger and sends only the list, so the screen never holds the old entries. Asked again whenever
 * the data reloads, since any change can earn or lose one. Null until the first answer arrives.
 */
export function useAchievementHistory(fetchedAt: string) {
  const [history, setHistory] = useState<Achievement[] | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let current = true;
    api<{ history: Achievement[] }>("achievements")
      .then((result) => {
        if (!current) return;
        setHistory(result.history);
        setFailed(false);
      })
      .catch(() => { if (current) setFailed(true); });
    return () => { current = false; };
  }, [fetchedAt]);
  return { history, failed };
}
